module.exports = __webpack_public_path__ + "img/irose-test4-step1b.7192706c.png";